const API_BASE_URL = process.env.REACT_APP_BASE_API_URL;

export const updatePayment = async (leadId, paymentId, paymentData) => {
    const token = localStorage.getItem('token');

    const payload = {
        ...paymentData
    };

    try {
        const response = await fetch(`${API_BASE_URL}/admin/lead/leads/payments/${paymentId}`, {
            method: 'PATCH',
            headers: {
                'Accept': 'application/json',
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });

        if (!response.ok) {
            const errorData = await response.json();
            throw errorData;
        }
        const data = await response.json();
        return data;
    } catch (error) {
        throw error;
    }
};